import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  position: "relative",
});

export const progressBarStyle = style({
  maxWidth: "100%",
});

export const columnsCardContentStyle = style({
  flexDirection: "column",
  gap: theme.spacings.s,
  alignItems: "flex-start",
  ...responsiveContainer({
    s: {
      flexDirection: "row",
      gap: theme.spacings.l,
    },
    m: {
      gap: theme.spacings.xl,
    },
  }),
});
